import { v4 as uuidv4 } from 'uuid';
import { ExampleNodeBuilder } from '../../builder/ExampleNodeBuilder';
import { LogicalType } from '../LogicalType';
import { Type } from '../Type';
export class ExampleObject extends Map {
    type = Type.Object;
    logicalType;
    tags;
    constructor(items = {}, logicalType, tags) {
        super(items instanceof Map ? items : Object.entries(items));
        this.logicalType = logicalType;
        this.tags = tags;
    }
    static new() {
        return new ExampleObjectBuilder();
    }
}
class ExampleObjectBuilder {
    logicalType;
    items = new Map();
    setLogicalType(logicalType) {
        this.logicalType =
            logicalType instanceof LogicalType
                ? logicalType
                : new LogicalType(logicalType, 1);
        return this;
    }
    addItem(key, value, build) {
        const builder = ExampleNodeBuilder.newSample(uuidv4(), value);
        if (build)
            build(builder);
        const node = builder.build();
        this.items.set(key, node);
        return this;
    }
    build() {
        return new ExampleObject(this.items, this.logicalType);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXhhbXBsZU9iamVjdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvb2JqZWN0L0V4YW1wbGVPYmplY3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEVBQUUsSUFBSSxNQUFNLEVBQUUsTUFBTSxNQUFNLENBQUE7QUFFbkMsT0FBTyxFQUFFLGtCQUFrQixFQUFFLE1BQU0sa0NBQWtDLENBQUE7QUFFckUsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLGdCQUFnQixDQUFBO0FBQzVDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxTQUFTLENBQUE7QUFHOUIsTUFBTSxPQUFPLGFBQ1gsU0FBUSxHQUF3QjtJQUd2QixJQUFJLEdBQVMsSUFBSSxDQUFDLE1BQU0sQ0FBQTtJQUN4QixXQUFXLENBQWM7SUFDekIsSUFBSSxDQUFXO0lBRXhCLFlBQ0UsUUFBZ0UsRUFBRSxFQUNsRSxXQUF5QixFQUN6QixJQUFlO1FBRWYsS0FBSyxDQUFDLEtBQUssWUFBWSxHQUFHLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFBO1FBQzNELElBQUksQ0FBQyxXQUFXLEdBQUcsV0FBVyxDQUFBO1FBQzlCLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFBO0lBQ2xCLENBQUM7SUFDRCxNQUFNLENBQUMsR0FBRztRQUNSLE9BQU8sSUFBSSxvQkFBb0IsRUFBRSxDQUFBO0lBQ25DLENBQUM7Q0FDRjtBQUVELE1BQU0sb0JBQW9CO0lBQ2hCLFdBQVcsQ0FBYztJQUN6QixLQUFLLEdBQTZCLElBQUksR0FBRyxFQUFFLENBQUE7SUFFbkQsY0FBYyxDQUFDLFdBQWlDO1FBQzlDLElBQUksQ0FBQyxXQUFXO1lBQ2QsV0FBVyxZQUFZLFdBQVc7Z0JBQ2hDLENBQUMsQ0FBQyxXQUFXO2dCQUNiLENBQUMsQ0FBQyxJQUFJLFdBQVcsQ0FBQyxXQUFXLEVBQUUsQ0FBQyxDQUFDLENBQUE7UUFDckMsT0FBTyxJQUFJLENBQUE7SUFDYixDQUFDO0lBRUQsT0FBTyxDQUNMLEdBQVcsRUFDWCxLQUFtQixFQUNuQixLQUEwQztRQUUxQyxNQUFNLE9BQU8sR0FBRyxrQkFBa0IsQ0FBQyxTQUFTLENBQUMsTUFBTSxFQUFFLEVBQUUsS0FBSyxDQUFDLENBQUE7UUFDN0QsSUFBSSxLQUFLO1lBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFBO1FBQ3pCLE1BQU0sSUFBSSxHQUFHLE9BQU8sQ0FBQyxLQUFLLEVBQUUsQ0FBQTtRQUM1QixJQUFJLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxHQUFHLEVBQUUsSUFBSSxDQUFDLENBQUE7UUFFekIsT0FBTyxJQUFJLENBQUE7SUFDYixDQUFDO0lBRUQsS0FBSztRQUNILE9BQU8sSUFBSSxhQUFhLENBQUMsSUFBSSxDQUFDLEtBQUssRUFBRSxJQUFJLENBQUMsV0FBVyxDQUFDLENBQUE7SUFDeEQsQ0FBQztDQUNGIn0=